// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MobileNounBRActivityRow_wrapper__3U-sx","icon":"MobileNounBRActivityRow_icon__2YFoy","content":"MobileNounBRActivityRow_content__1JzsS"};